{
    "background": {
        "type": "linear",
        "start": "#002d70",
        "stop": "#0066ff",
        "angle": 0,
        "id": "linear:0:#002d70:#0066ff"
    },
    "foreground": {
        "type": "none"
    },
    "foregroundOpacity": 1,
    "size": 144,
    "padding": 0.25,
    "rotation": 0,
    "radius": 0,
    "radiusType": "arc",
    "backgroundImage": null,
    "backgroundOpacity": 1,
    "shadow": {
        "color": "#000000",
        "opacity": 0,
        "blur": 0,
        "distance": 0,
        "angle": 0
    }
}